module.exports = __webpack_public_path__ + "img/1F6B7.a9f9db78.svg";